import { GetCarInfoResponse } from "./model"

export const mapCarInfoResponse = (response: GetCarInfoResponse): GetCarInfoResponse => {
    return {
        carInfos: response.carInfos,
        minDate: response.minDate && new Date(response.minDate),
        maxDate: response.maxDate && new Date(response.maxDate),
    }
}
